import { IOWObject } from "OW.Remoting/Remoting/DataTypes/IOWObject";
import { IRightsParams } from "./types";

//TODO: Dokumentace třídy, proč je vůbec potřeba a kde
export class RightsParams implements IRightsParams {
    public readonly evaluateFormRights: boolean;
    public readonly objectName: string;
    public readonly masterObject: IOWObject;
    private _masterLinkToAttr: string;

    public get masterObjectInstanceID(): string | null {
        return this.masterObject?.instanceID || null;
    }

    public get masterLinkToAttr(): string {
        return this._masterLinkToAttr;
    }

    constructor(evaluateFormRights: boolean = null,
        objectName: string = null,
        masterObject: IOWObject = null,
        masterLinkToAttr: string = null) {
        this.evaluateFormRights = evaluateFormRights;
        this.objectName = objectName;
        this.masterObject = masterObject;
        this._masterLinkToAttr = masterLinkToAttr;
    }
}
